<template>
  <div v-if="!bloquearComunicacion" class="message-input">
    <textarea v-if="incidenciaCerrada"
      v-model="chatNoDisponible"
      disabled="true"
    ></textarea>
    <textarea v-if="!incidenciaCerrada"
      ref="messageInput"
      placeholder=""
      maxlength="20000"
      @keydown.enter="submitMessage"
    ></textarea>

      <v-icon v-if="!incidenciaCerrada" id="icono" @click="$refs.file.click()">attach_file</v-icon>
      <input v-if="!incidenciaCerrada" type="file" accept=".jpg, .jpeg, .png" style="display:none;" id="file" ref="file" v-on:change="handleFileUpload(); clear()"/>
  </div>
</template>

<script>

import {mapActions,mapGetters} from 'vuex'
import moment from 'moment'

export default {
  name: 'message-input',
  props: {
    idIncidencia: String,
    detalleIncidencia: Object
  },
  data () {
    return {
      file: '',
      loader: null
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      guardarRegistroMensaje: 'chat/guardarRegistroMensaje'
    }),
    clear () {
      let input = this.$refs.file
      input.type = 'text'
      input.type = 'file'
    },
    submitMessage (event) {
      if (!event.shiftKey) {
        event.preventDefault()
      } else {
        return
      }

      // If the message body is empty, do not submit
      if (event.target.value.length === 0) {
        return
      }

      if (!event.target.value.replace(/\s/g, '').length) {
        return
      }

      // If the message body is empty, do not submit
      /*if (event.target.value.length > 255) {
        this.addAlert({texto: 'El mensaje es demasiado largo. No puede contener más de 255 caracteres', color: 'error'})
        return
      }*/

      this.publicarMensaje(event.target.value, false, null)

      // Reset the text input
      event.target.value = ''
    },
    handleFileUpload () {
      let messageInput = this
      var file = this.$refs.file.files[0]

      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png') {
        return this.addAlert({ texto: this.$t('seleccionarArchivoFormatoCorrecto'), color: 'error' })
      }
      if (file.size > 500000) {
        return this.addAlert({texto: this.$t('imagenDemasiadoGrande'), color: 'error'})
      }
      console.log('datos imagen', file)
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        messageInput.downscaleImage(reader.result, 1024, file.type, null, file.name)
      }
      reader.onerror = function (error) {
        console.log('Error: ', error)
      }
    },
    publicarMensaje (mensaje, imagen, nombreFichero) {
      if(this.idIncidencia == 0) return
      const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      const userUUID = usuarioJson.id
      let messageInput = this

      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      })

      this.guardarRegistroMensaje({
          canal: this.canal,
          mensaje: mensaje,
          usuario: userUUID,
          imagen: imagen,
          id_incidencia: this.idIncidencia,
          nombre_fichero: nombreFichero,
          ids_receptores: this.detalleIncidencia.receptores || []
        }).then(e => {
          messageInput.loader.hide()
          if(imagen === true) {
            // si es imagen, solo enviamos el id de la imagen
            mensaje = e.data.result.data.id_imagen[0]
          }
          messageInput.$pnPublish({
            channel: messageInput.canal,
            message: {
              text: mensaje,
              uuid: userUUID,
              nombre: usuarioJson.nombre,
              imagen: imagen,
              timetoken: moment().format('YYYY-MM-DD HH:mm:ss')
            }
          })

          messageInput.$emit('recargar')


        })
        .catch(e => {
          console.log(e)
        })

      // console.log(even.target.value);
      // Publish to PubNub the text and user's uuid

    },
    // Take an image URL, downscale it to the given width, and return a new image URL.
    downscaleImage (dataUrl, newWidth, imageType, imageArguments, nombreFichero) {
      'use strict'
      var image, oldWidth, oldHeight, newHeight, canvas, ctx, newDataUrl
      let messageInput = this
      // Provide default values
      imageType = imageType || 'image/png'
      imageArguments = 1

      // Create a temporary image so that we can compute the height of the downscaled image.
      image = new Image()
      image.src = dataUrl

      image.onload = function () {

        oldWidth = image.width
        oldHeight = image.height
        console.log('tamanos')
        if(newWidth > oldWidth) {
          // es mayor no redimensionamos
          newWidth = oldWidth
          newHeight = oldHeight
        } else {
          newHeight = Math.floor(oldHeight / oldWidth * newWidth)
        }

        // Create a temporary canvas to draw the downscaled image on.
        canvas = document.createElement('canvas')
        canvas.width = newWidth
        canvas.height = newHeight

        // Draw the downscaled image on the canvas and return the new data URL.
        ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, newWidth, newHeight)
        newDataUrl = canvas.toDataURL(imageType, imageArguments)

        messageInput.publicarMensaje(newDataUrl, true, nombreFichero)

      }
    }
  },
  computed: {
    ...mapGetters({
      getConfiguracion: 'configuracion/getConfiguracion',
    }),
    chatNoDisponible () {
      return this.$t('chatNoDisponible')
      // } else if(this.detalleIncidencia.codigoEstado == "90" || this.detalleIncidencia.statusCode == "90"){
      //   return this.$t('chatNoDisponibleRech')
      // }
      // return ''
    },
    canal () {
      if (this.$store.state.chat.canal) {
        return this.$store.state.chat.canal
      }
      return 'vueChat'
    },
    bloquearComunicacion () {
      if(typeof this.detalleIncidencia === "undefined"){
        return false
      }
      let cod_estado = this.detalleIncidencia.statusCode || this.detalleIncidencia.codigoEstado
      if(this.getConfiguracion.bloquearChatCerradas === true){
        if(cod_estado == "50" || cod_estado == "30"){
          return true;
        }
      }
      return false
    },
    incidenciaCerrada () {
      // 
      let estados = this.detalleIncidencia.estados || []
      // si esta cerrada o rechazada
      console.log('estados', estados)
      if(estados.length > 0 && (estados[0].codigo == '50'/*  || estados[0].codigo == '90') */)){
        
        var diasVisibleCliente = this.getConfiguracion.diasVisibleCliente
        // var mCloseDate = moment(this.detalleIncidencia.closeDate, 'DD-MM-YYYY')
        // usamos estados[0].fecha que viene en format YYYY-MM-DD
        var mCloseDate = moment(estados[0].fecha, 'YYYY-MM-DD')
        console.log('mCloseDate', mCloseDate)
        console.log('diasVisibleCliente', diasVisibleCliente)
        
        mCloseDate = mCloseDate.add(diasVisibleCliente, 'days')
        console.log('mCloseDate', mCloseDate)

        var closeDateTime = new Date(mCloseDate).getTime()
        var todayDateTime = new Date().getTime()

        if (closeDateTime < todayDateTime) {
          return true
        }
      }
      return false
    },
  }
}
</script>

<style scoped>
.message-input {
  display: table-row;
  width: 100%;
  height: 26px;
}

textarea {
  width: calc(100% - 50px);
  height: 100px;
  padding: 0 5px;
  margin-left:10px;
  box-sizing: border-box;
  line-height: 20pt;
  resize: none;
  outline: none;
  font-size: 14px;
  border: solid 1px #AAAAAA;
  border-radius: 3px;
  font-family: Helvetica;
}

#icono {
  width: 30px;
  float: right;
  margin-right: 10px
}
</style>
